import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { toastWarning } from '../../../util/toastUtils';
import * as crosstabActions from '../../../actions/crosstabActions';

class FirstHeaderColumn extends Component {
  constructor(props) {
    super(props);
    this.state = {
      crosstabTitle: '',
    };
  }

  UNSAFE_componentWillMount() {
    const { loadedCrosstabInfo } = this.props;
    const crosstabTitle = loadedCrosstabInfo.tableTitle;
    this.setState({ crosstabTitle });
    this.props.onValueChange(crosstabTitle);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.tableData
      && (nextProps.loadedCrosstabInfo.title !== this.state.crosstabTitle)
    ) {
      this.setState({ crosstabTitle: nextProps.loadedCrosstabInfo.tableTitle });
      this.props.onValueChange(nextProps.loadedCrosstabInfo.tableTitle);
    }
  }

  handleCrosstabTitleChange = e => {
    if (e.target.value.length === 0 || e.target.value.trim()) {
      this.setState({ crosstabTitle: e.target.value });
    }
  };

  handleCrosstabTitleBlur = () => {
    const { crosstabTitle } = this.state;
    const { loadedCrosstabInfo } = this.props;
    this.props.crosstabActions.saveCrosstabTableTitle({
      ...loadedCrosstabInfo,
      title: crosstabTitle,
    });
  };

  handleSaveButton = () => {
    const { crosstabTitle } = this.state;
    this.props.handleCrosstabSaveButton(crosstabTitle);
    this.props.onValueChange(crosstabTitle);
  };

  render() {
    return (
      <div className="column left-column-width main-table-left-column">
        {this.props.showSave &&
          <div className="main-table-left-column-save" style={{ height: this.props.columnHeight }}>
            <input
              type="text"
              placeholder={this.props.placeholder}
              onChange={this.handleCrosstabTitleChange}
              onBlur={this.handleCrosstabTitleBlur}
              value={this.state.crosstabTitle}
            />
            <button
              className="main-table-left-column-save-btn"
              onClick={() => {
                if (this.state.crosstabTitle) {
                  this.handleSaveButton();
                } else {
                  toastWarning(this.props.warningText);
                }
              }}
              title="Save"
            />
          </div>}
        {!this.props.showSave && <div className="main-table-left-column-save" />}
        <div className="main-table-left-column-filter">
          <div className="new-highlightAndFilter">
            <div className="margin-lr15">
              <div className="toggle-bgc">
                <input
                  id="toggle-on"
                  onClick={() => this.props.handleHighlightShowButton()}
                  className="toggle-hnf toggle-left"
                  name="toggle-hnf"
                  type="radio"
                />
                <label
                  htmlFor="toggle-on"
                  className="btn-hnf highlight-off"
                  title="Highlight &amp; Filter"
                >
                  &nbsp;
                </label>
                <input
                  id="toggle-off"
                  onClick={() => this.props.highlightRadioButton(false)}
                  className="toggle-hnf toggle-right"
                  name="toggle-hnf"
                  type="radio"
                  defaultChecked
                />
                <label
                  htmlFor="toggle-off"
                  className="btn-hnf highlight-on"
                  title="Reset Highlight &amp; Filter"
                >
                  &nbsp;
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

FirstHeaderColumn.propTypes = {
  crosstabActions: PropTypes.shape({
    saveCrosstabTableTitle: PropTypes.func,
  }),
  handleCrosstabSaveButton: PropTypes.func,
  loadedCrosstabInfo: PropTypes.shape({}),
  highlightRadioButton: PropTypes.func,
  onValueChange: PropTypes.func,
  handleHighlightShowButton: PropTypes.func,
  showSave: PropTypes.bool,
  warningText: PropTypes.string,
  placeholder: PropTypes.string,
  columnHeight: PropTypes.string,
};

function mapStateToProps(state) {
  return {
    loadedCrosstabInfo: state.crosstab.loadedCrosstabInfo,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    crosstabActions: bindActionCreators(crosstabActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps, null)(React.memo(FirstHeaderColumn));
